var _defs, _g, _g2, _path, _g3, _path2, _path3, _g4, _path4, _g5, _g6, _path5, _g7, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "530b4373d9"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "307c54d959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.804688 5 L 319.546875 5 L 319.546875 353 L 43.804688 353 Z M 43.804688 5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38551f2443"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.804688 5 L 125 5 L 125 86 L 43.804688 86 Z M 43.804688 5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3b367e0bd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.804688 84 L 127 84 L 127 193 L 43.804688 193 Z M 43.804688 84 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2160e19e25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#530b4373d9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#000000",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 0.72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "552332a0b4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 84,
    y: 0,
    height: 109
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54918290be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 96.039062 130.964844 L 269 130.964844 L 269 304 L 96.039062 304 Z M 96.039062 130.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5b1758cf77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 261 296 L 336 296 L 336 370.824219 L 261 370.824219 Z M 261 296 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cced41caae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 107.964844 143.46875 L 255.398438 143.46875 L 255.398438 290.902344 L 107.964844 290.902344 Z M 107.964844 143.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c0d20c1124"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 181.679688 143.46875 C 140.96875 143.46875 107.964844 176.472656 107.964844 217.183594 C 107.964844 257.898438 140.96875 290.902344 181.679688 290.902344 C 222.394531 290.902344 255.398438 257.898438 255.398438 217.183594 C 255.398438 176.472656 222.394531 143.46875 181.679688 143.46875 Z M 181.679688 143.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b627510d6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142 176 L 221 176 L 221 256 L 142 256 Z M 142 176 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "debabeb67d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.3125 215.835938 L 181.667969 143.480469 L 254.023438 215.835938 L 181.667969 288.191406 Z M 109.3125 215.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "07195662c4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.3125 215.835938 L 181.667969 143.480469 L 254.023438 215.835938 L 181.667969 288.191406 Z M 109.3125 215.835938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#307c54d959)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2e8f0",
    d: "M 70.96875 352.132812 L 292.378906 352.132812 C 307.492188 352.132812 319.976562 339.648438 319.976562 324.539062 L 319.976562 33.15625 C 319.976562 18.046875 307.492188 5.5625 292.378906 5.5625 L 124.84375 5.5625 L 43.375 85.714844 L 43.375 324.539062 C 43.375 339.648438 55.859375 352.132812 70.96875 352.132812 Z M 70.96875 352.132812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38551f2443)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7fafc",
    d: "M 124.84375 5.5625 L 124.84375 85.714844 L 43.375 85.714844 Z M 124.84375 5.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e2e8f0",
    d: "M 279.242188 116.265625 L 279.242188 264.75 L 84.109375 264.75 L 84.109375 116.265625 Z M 95.605469 158.316406 L 215.183594 158.316406 L 215.183594 127.765625 L 95.9375 127.765625 L 95.9375 158.316406 Z M 215.183594 170.140625 L 95.9375 170.140625 L 95.9375 206.605469 L 215.183594 206.605469 Z M 226.679688 206.605469 L 267.414062 206.605469 L 267.414062 170.140625 L 226.679688 170.140625 Z M 226.679688 127.765625 L 226.679688 158.316406 L 267.414062 158.316406 L 267.414062 127.765625 Z M 267.414062 218.101562 L 226.679688 218.101562 L 226.679688 252.925781 L 267.414062 252.925781 Z M 215.183594 253.253906 L 215.183594 218.101562 L 95.9375 218.101562 L 95.9375 252.925781 L 215.183594 252.925781 Z M 215.183594 253.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3b367e0bd0)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#2160e19e25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 43, 84)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#552332a0b4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#718096",
    d: "M 1.03125 1.714844 L 81.1875 1.714844 L 1.03125 106.507812 Z M 1.03125 1.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.100278, 0.000000000000000331, -0.000000000000000331, 1.100278, 145.381752, 30.091481)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.000915 2.998463 L 138.793975 2.998463 ",
    stroke: "#718096",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.100278, 0, 0, 1.100278, 145.381737, 75.818498)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.000928 3.0016 L 113.147068 3.0016 ",
    stroke: "#718096",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#54918290be)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#718096",
    d: "M 182.378906 130.980469 C 134.886719 130.980469 96.253906 169.613281 96.253906 217.105469 C 96.253906 264.597656 134.886719 303.230469 182.378906 303.230469 C 229.871094 303.230469 268.503906 264.597656 268.503906 217.105469 C 268.503906 169.613281 229.871094 130.980469 182.378906 130.980469 Z M 182.378906 289.695312 C 142.355469 289.695312 109.789062 257.128906 109.789062 217.105469 C 109.789062 177.078125 142.355469 144.515625 182.378906 144.515625 C 222.40625 144.515625 254.96875 177.078125 254.96875 217.105469 C 254.96875 257.128906 222.40625 289.695312 182.378906 289.695312 Z M 182.378906 289.695312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#718096",
    d: "M 268.664062 291.320312 L 253.460938 276.117188 C 249.683594 280.660156 245.484375 284.832031 240.917969 288.582031 L 256.355469 304.019531 C 257.335938 301.210938 258.941406 298.578125 261.183594 296.339844 L 261.613281 295.90625 C 263.648438 293.871094 266.046875 292.328125 268.664062 291.320312 Z M 268.664062 291.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5b1758cf77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#718096",
    d: "M 286 300.363281 C 283.351562 297.71875 279.8125 296.257812 276.035156 296.257812 C 272.257812 296.257812 268.71875 297.71875 266.070312 300.363281 L 265.640625 300.796875 C 262.992188 303.445312 261.535156 306.984375 261.535156 310.761719 C 261.535156 314.539062 262.992188 318.078125 265.640625 320.726562 L 311.445312 366.53125 C 314.09375 369.179688 317.632812 370.640625 321.410156 370.640625 C 325.1875 370.640625 328.726562 369.179688 331.375 366.53125 L 331.808594 366.101562 C 337.300781 360.605469 337.300781 351.664062 331.808594 346.171875 Z M 286 300.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cced41caae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c0d20c1124)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#edf2f7",
    d: "M 107.964844 143.46875 L 255.394531 143.46875 L 255.394531 290.902344 L 107.964844 290.902344 Z M 107.964844 143.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.100278, 0, 0, 1.100278, 145.381737, 98.609576)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.000928 2.999769 L 76.597366 2.999769 ",
    stroke: "#718096",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b627510d6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#debabeb67d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#07195662c4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4a5568",
    d: "M 203.386719 179.65625 L 181.648438 201.394531 L 159.941406 179.6875 C 155.945312 175.691406 149.460938 175.691406 145.46875 179.6875 C 141.472656 183.679688 141.472656 190.164062 145.46875 194.160156 L 167.175781 215.867188 L 145.496094 237.546875 C 141.503906 241.539062 141.503906 248.023438 145.496094 252.015625 C 149.492188 256.011719 155.976562 256.011719 159.96875 252.015625 L 181.648438 230.335938 L 203.359375 252.046875 C 207.355469 256.042969 213.839844 256.042969 217.832031 252.046875 C 221.828125 248.054688 221.828125 241.570312 217.832031 237.574219 L 196.121094 215.863281 L 217.859375 194.128906 C 221.851562 190.132812 221.851562 183.648438 217.859375 179.65625 C 213.863281 175.660156 207.382812 175.660156 203.386719 179.65625 Z M 203.386719 179.65625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.100278, 0, 0, 1.100278, 145.381737, 52.37746)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.000928 3.001266 L 92.889409 3.001266 ",
    stroke: "#718096",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataLight);
export default __webpack_public_path__ + "static/media/no-data-light.ecde47fae0a7aebd5f061a3f703ff139.svg";
export { ForwardRef as ReactComponent };